import React from 'react'
import { BlockMain } from '@blocks/BlockMain'
import { ApplicationForms } from '@shared/components/forms/application'
import { scrollToLoanForm } from '@shared/components/forms/new-loan'
import { LoanForm } from '@shared/components/forms/new-loan'
import { loanFormAllPurposes } from '@shared/components/forms/new-loan/shared/option-types/purposes'
import PageAnimation from '@shared/components/page-animation'
import { Faq } from '@shared/components/sections/faq'
import { PartnerLogos } from '@shared/components/sections/partner-logos'

import { ProductPageData } from '../../data/products-pages'

import { ProductAdvantage } from './sections/advantage'
import { ProductCard } from './sections/card'
import { GetLoanEasy } from './sections/get-loan-easy'
import { TypesOfProperty } from './sections/types-of-property'

import styles from './style.module.scss'

export const View = ({ mainBlockTitle, card, loanStepsTitle, faq, minLoan }: ProductPageData) => (
	<PageAnimation>
		<BlockMain
			adornmentClassname={styles.mainAdornment}
			data={{
				title: mainBlockTitle,
				footnote: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
				imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
				description: '',
				faceImageName: {
					mobile: 'KV-loans-business-mob.png',
					default: 'keyvisual-loans-business.png',
				},
				buttonText: 'Оставить заявку',
				textItems: ['До 15 миллионов рублей', 'До 5 лет', 'Без справок о доходах'],
			}}
			buttonProps={{
				onClick: scrollToLoanForm,
			}}
		/>
		<PartnerLogos />
		<ProductCard {...card} />
		{/* <TypesOfProperty /> */}
		<GetLoanEasy title={loanStepsTitle} />
		<ProductAdvantage />
		<ApplicationForms.Cross
			processBarText='Вероятность одобрения займа'
			formTitle='Заявка на заём'
			minLoan={minLoan}
		/>
		<Faq accordionElements={faq} />
	</PageAnimation>
)
